import Styles from './Console.module.css';

import React, { useEffect, useState, useRef } from 'react';
import socket from '../../socket';

import JsonView from '@uiw/react-json-view';

import config from '../../utils/config';

const Console = () => {
  const [games, setGames] = useState({});
  const [gameSelected, setGameSelected] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const gameSelectedRef = useRef(null); // Almacena el valor actual de gameSelected
  const [formValues, setFormValues] = useState({
    game: '597092ff-5eac-4731-ae63-cd8e2a411219',
    module: 1,
    user: 'a4885408-4081-70e7-9ac1-9fa3c93cf2ed',
    room: 'c56f1ec0-72f7-41a7-9d4c-c519c52ffc14',
    players: 1,
  });


  const handleEvent = (data) => {
    console.log("got data", data);

    if (data.type === 'games') {
      setGames(data.data);

      // Mantener el juego seleccionado actual si sigue siendo válido
      if (gameSelectedRef.current && gameSelectedRef.current in data.data) {
        setGameSelected(gameSelectedRef.current);
      } else {
        // De lo contrario, seleccionar el primer juego de la lista
        const firstKey = Object.keys(data.data)[0];
        setGameSelected(firstKey || null); // Manejar el caso donde no haya juegos
        gameSelectedRef.current = firstKey || null;
      }
    }
  };

  useEffect(() => {
    gameSelectedRef.current = gameSelected;
  }, [gameSelected]);


  useEffect(() => {
    socket.emit("console_get_games");
    socket.on('welcome', handleEvent);
    socket.on('console_event', handleEvent);
  }, [])

  const GameCount = () => {
    //count the number of keys on the games object
    return Object.keys(games).length;
  }

  const UpdateGames = () => {
    socket.emit("console_get_games");
  }

  const ToggleTimer = () => {
    socket.emit("console_toggle_timer", { gameId: gameSelected });
  }

  const PrevState = () => {
    socket.emit("console_prev_state", { gameId: gameSelected });
  }

  const NextState = () => {
    socket.emit("console_next_state", { gameId: gameSelected });
  }

  const KillGame = () => {
    socket.emit("console_kill_game", { gameId: gameSelected });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  }

  const handleJoinGame = () => {
    const { game, module, user, room, players } = formValues;
    const url = `${config.host}/?game=${game}&module=${module}&user=${user}&room=${room}&players=${players}`;
    window.open(url, '_blank');
    setShowPopup(false);
  }


  return (
    <div>
      <h1>Console</h1>
      <button onClick={UpdateGames}>🔄 Update</button>
      <button onClick={() => setShowPopup(true)}>Join a Game</button>
      <p>Current Games: {GameCount()}</p>

      <select
        value={gameSelected || ''}
        onChange={(e) => {
          const value = e.target.value;
          setGameSelected(value);
          gameSelectedRef.current = value; // Actualizar el ref
        }}
      >
        {Object.keys(games).map((gameId) => (
          <option key={gameId} value={gameId}>
            {gameId}
          </option>
        ))}
      </select>


      {showPopup && (
        <div className={Styles.popup}>
          <div className={Styles.popupContent}>
            <h2>Join a Game</h2>
            <form>
              <label>
                Game:
                <select name="game" value={formValues.game} onChange={handleChange}>
                  <option value="597092ff-5eac-4731-ae63-cd8e2a411219">Game #1</option>
                </select>
              </label>
              <br />
              <label>
                Module:
                <input type="number" name="module" value={formValues.module} onChange={handleChange} />
              </label>
              <br />
              <label>
                User:
                <select name="user" value={formValues.user} onChange={handleChange}>
                  <option value="a4885408-4081-70e7-9ac1-9fa3c93cf2ed">Yenni Trujillo</option>
                  <option value="5488a4b8-9031-7088-15c7-b124d8fe3a4a">Camilo A.</option>
                  <option value="d478b428-3061-70cb-09dd-b9f3c77aed27">Verónica M.</option>
                </select>
              </label>
              <br />
              <label>
                Room:
                <input type="text" name="room" value={formValues.room} onChange={handleChange} />
              </label>
              <br />
              <label>
                Players:
                <input type="number" name="players" value={formValues.players} onChange={handleChange} />
              </label>
              <br />
              <button type="button" onClick={handleJoinGame}>Join Game</button>
              <button type="button" onClick={() => setShowPopup(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      {gameSelected && <div>
        <h3>Game Tools</h3>
        <div className={Styles.row} >
          <button onClick={ToggleTimer} className={games[gameSelected].timerEnabled ? Styles.green : Styles.red} >
            {games[gameSelected].timeToStart} {games[gameSelected].timerEnabled ? "⏸️ Pause Timer" : "▶️ Resume Timer"}
          </button>
          <button onClick={PrevState}>
            ⏪ Previous State
          </button>
          <button onClick={NextState}>
            Next State ⏩
          </button>
          <button onClick={KillGame}>
            ❌ Kill Game
          </button>
        </div>

        <div className={Styles.card}><JsonView value={games[gameSelected]} /></div>
      </div>}

    </div>
  );
};

export default Console;